import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber, FormattedMessage, injectIntl } from 'react-intl';
import { Div, Flex } from 'ui';
import { isObjectNullOrEmpty } from 'utils/helpers';
import FormattedCurrencyNumber from 'common/formatted-currency-number/formatted-currency-number';
import ToggleFilter from '../../../common/toolbar/components/toggle-filter';

const Wrapper = styled(Flex)`
  color: #9b9b9b;
  margin-left: 30px;
`;

const ToolbarItem = styled(Div)`
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-flow: row wrap;
`;

const ToolbarItemFilter = styled(ToolbarItem)`
  > label {
    font-size: 20px;
    font-weight: 600;
  };
  > div > label {
    font-size: 18px;
  };
  label:not(.ant-radio-button-wrapper-checked) {
    color: #9b9b9b !important;
  };
`;

const ItemWrapper = styled.div`
  margin-left: 5px;
  display: flex;
  flex-flow: row nowrap;
  white-space: nowrap;
  div:not(:last-child):after {
    content: " +";
    margin-right: 5px;
  }
`;

const PartToolbar = ({ intl, parts, filter, filterOptions, handleFilterChange }) => {
  const reduceParts = (amount, unit) => parts?.reduce(
    (tot, part) => ({
      ...tot,
      // eslint-disable-next-line max-len
      [part[unit] || 'none']: (tot[part[unit]] || 0) + (part[amount] * part.quantityOrdered),
    }),
    {},
  );

  const totalWeight = reduceParts('weight', 'weightUnit');
  const actualCost = reduceParts('cost', 'costCurrency');

  const renderTotalAmount = (amount, isCurrency = false) => <ItemWrapper>
    {isObjectNullOrEmpty(amount) ?
      0 :
      Object.keys(amount).map((c, i) => {
        if (c !== 'none' && isCurrency) {
          return <div key={i}>
            <FormattedCurrencyNumber
              value={amount[c]}
              // eslint-disable-next-line
              style='currency'
              currency={c}
            />
          </div>;
        }
        return <div key={i}>
          {/* eslint-disable-next-line no-nested-ternary */}
          <FormattedNumber value={amount[c]} />{!isCurrency ? c === 'none' ? '' : c : null}
        </div>;
      })}
  </ItemWrapper>;

  return (
    <Wrapper>
      <ToolbarItem>
        <FormattedMessage id='order.parts.TOTAL_COST' />{' '}
        {renderTotalAmount(actualCost, true) || 0}
      </ToolbarItem>{' '}
      |{' '}
      <ToolbarItem>
        <FormattedMessage id='order.parts.TOTAL_WEIGHT' />
        {renderTotalAmount(totalWeight) || 0}
      </ToolbarItem>{' '}
      |
      <ToolbarItemFilter>
        <ToggleFilter
          value={filter}
          items={filterOptions}
          label={intl.formatMessage({ id: 'order.parts.FILTER' })}
          onChange={e => handleFilterChange(e.target.value)}
        />
      </ToolbarItemFilter>
    </Wrapper>
  );
};

PartToolbar.propTypes = {
  parts: PropTypes.array,
  filterOptions: PropTypes.array,
  filter: PropTypes.string,
  handleFilterChange: PropTypes.func,
  intl: PropTypes.object,
};

export default injectIntl(PartToolbar);
